import header from '../modules/header/index';
import initInfoGallery from '../modules/initInfoGallery';
import addHightToImageGalery from '../modules/addHightToImageGalery';
import productTooltipControl from '../modules/productTooltipControl';
import passiveListenersForJquery from '../modules/passiveListenersForJquery';
import addScrollToTop from '../modules/addScrollToTop';
import NewsletterAction from '../modules/newsletterAction';

import "../../../scss/pages/homePage.scss";
import {Apptus} from "../modules/apptus/apptus";

jQuery(function () {
  passiveListenersForJquery();
  header();
  initInfoGallery();
  addHightToImageGalery();
  productTooltipControl();
  addScrollToTop();

  $('.subscription').on('click', function () {

    NewsletterAction($(this));
  });
  
  $(window).on('click', (e) => {
    let target = e.target;
    var targetParent = $(target).parent();
    if(target.matches('.update-apptus-func') ) {
      Apptus.NotifyClick($(target).attr('data-apptus'))
    }
    if(targetParent.hasClass('update-apptus-func') ) {
      Apptus.NotifyClick($(targetParent).attr('data-apptus'))
    }
  })
})
